<template>
    <gofix-card fullContent class="mb-2">
        <gofix-default-table
                :settings="tableConfig"
                :table-items="tableItems"
                @new-item="openModalAdd"
                @load-items="getTableData"
                @row-click="edit"
                @delete-items="deleteItems"
                ref="gofixTable">
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" :title="titleModal" hide-footer :centered="true" ref="modal-EditPrioritySet">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="Name" v-model="transaction_types.name"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.posting_rules, 'update')">
                <gofix-button label="SUBMIT" @click="saveTransactionTypes" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters, mapState } from "vuex";
    export default {
        name: 'transaction-types',
        data() {
            return {
                tableConfig:{
                    name: 'posting-rules-transaction-types',
                    controls:{
                        create: this.$checkRole(this.$accessModule.chart_of_account, 'create'),
                        delete: this.$checkRole(this.$accessModule.chart_of_account, 'delete')
                    },
                    filter: JSON.parse(JSON.stringify(filters['transaction_types'])),
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "name",
                    sortDirection: "asc",
                },
                tableItems: [],
                isAction: false,
                transaction_types: {

                },
                titleModal: 'Create Transaction Type',
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                TransactionTypesItems: "PostingEntryController/TransactionTypesItems"
            })
        },
        mounted() {
            //
        },
        filters: {
            //
        },
        watch: {
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("PostingEntryController/getTransactionTypesItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$bvToast.toast("Can not load the items", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            async deleteItems(callback) {
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("PostingEntryController/deleteTransactionTypes", ids)
                    .then(response => {
                        resolve(response.data.data);
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },

            saveTransactionTypes(){
                if(this.isAction) {
                    return;
                }
                this.isAction = true;
                if (!this.transaction_types.name) {
                    this.isAction = false;
                    return this.$bvToast.toast('Name is a required field.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                let keyMessage= 'adding'
                if(this.transaction_types && this.transaction_types.id) {
                    keyMessage = 'editing'
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('PostingEntryController/saveTransactionTypes', this.transaction_types)
                        .then(result => {
                            this.isAction = false;
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.$bvToast.toast( this.$notificationV2(keyMessage, 'transaction_type'), {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'success',
                                solid: true
                            })
                            this.$refs["modal-EditPrioritySet"].hide();
                        })
                        .catch(error => {
                            this.isAction = false;
                        })
                }, 300)
            },
            edit(item){
                this.titleModal = 'Edit Transaction Type';
                this.transaction_types = Object.assign({}, item);
                this.$refs['modal-EditPrioritySet'].show()
            },
            openModalAdd (){
                this.titleModal = 'Create Transaction Type'
                this.transaction_types = {}
                this.$refs['modal-EditPrioritySet'].show()
            },
        }
    }
</script>
